'use client';

import dynamic from 'next/dynamic';

// The shared server dispatcher knows every template. Keep these client implementations
// behind their own entry points so unrelated pages do not preload their forms.
// SSR remains enabled: the rendered route still supplies its complete initial HTML.
export const SignInPanel = dynamic(() =>
  import('../auth/sign-in/sign-in-panel').then(module => module.SignInPanel),
);
export const RegisterFlow = dynamic(() =>
  import('../auth/register/register-flow').then(module => module.RegisterFlow),
);
export const CheckoutPage = dynamic(() =>
  import('../checkout/checkout-page').then(module => module.CheckoutPage),
);
export const HelpContactForm = dynamic(() =>
  import('../forms-pages/help-contact-form').then(module => module.HelpContactForm),
);
export const ClaimForm = dynamic(() =>
  import('../forms-pages/claim-form').then(module => module.ClaimForm),
);
export const OrderConfirmation = dynamic(() =>
  import('../checkout/confirmation/order-confirmation').then(module => module.OrderConfirmation),
);
export const ReturnView = dynamic(() =>
  import('../forms-pages/return-view').then(module => module.ReturnView),
);
